<div class="rtl relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-white border-0">
  <div class="rounded-t border-b-2 mb-0 p-6">
    <div class="text-center flex justify-between">
      <h6 class="text-primary text-xl font-bold"> نوبت ها </h6>

    </div>
  </div>

  <div class="flex flex-wrap pt-6">
    <div class="w-full lg:w-3/12 px-4">
      <div class="relative w-full mb-3">
        <label class="block text-blueGray-600 text-sm font-bold mb-2"> جستجو </label>
        <input type="text" [(ngModel)]="searchBody.title" (keyup)="getAppointmentList(1)"
          class="p-3 placeholder-blueGray-300 text-blueGray-600 border-gray-300 rounded text-sm w-full">
      </div>
    </div>
    <div class="w-full lg:w-3/12 px-4">
      <div class="relative w-full mb-3">
        <label class="block text-blueGray-600 text-sm font-bold mb-2"> نوع ویزیت</label>
        <select type="text" name="inshurance" [(ngModel)]="searchBody.type" (change)="getAppointmentList(1)"
          class="border-gray-300 p-3 placeholder-blueGray-300 text-blueGray-600 rounded text-sm w-full rtl">
          <option value="0">---</option>
          <option [value]="visitType.VideoVisit"> ویزیت تصویری</option>
          <option [value]="visitType.PhoneVisit"> ویزیت تلفنی</option>
          <option [value]="visitType.TextVisit"> ویزیت متنی </option>
          <option [value]="visitType.BodyVisit"> ویزیت حضوری </option>
        </select>
      </div>
    </div>
    <div class="w-full lg:w-3/12 px-4">
      <div class="relative w-full mb-3">
        <label class="block text-blueGray-600 text-sm font-bold mb-2"> وضعیت پرداخت</label>
        <select type="text" name="inshurance" [(ngModel)]="searchBody.paymentStatus" (change)="getAppointmentList(1)"
          class="border-gray-300 p-3 placeholder-blueGray-300 text-blueGray-600 rounded text-sm w-full rtl">
          <option value="0">---</option>
          <option [value]="paymentStatus.Pending"> در انتظار تایید </option>
          <option [value]="paymentStatus.Approved"> تایید شده </option>
          <option [value]="paymentStatus.NotApproved"> رد شده </option>
        </select>
      </div>
    </div>
    <div class="w-full lg:w-3/12 px-4">
      <div class="relative w-full mb-3">
        <label class="block text-blueGray-600 text-sm font-bold mb-2"> وضعیت ویزیت </label>
        <select type="text" name="inshurance" [(ngModel)]="searchBody.status" (change)="getAppointmentList(1)"
          class="border-gray-300 p-3 placeholder-blueGray-300 text-blueGray-600 rounded text-sm w-full rtl">
          <option value="0">---</option>
          <option [value]="visitStatus.Pending"> در انتظار تایید </option>
          <option [value]="visitStatus.Approved"> تایید شده </option>
          <option [value]="visitStatus.Cancelled"> کنسل شده </option>
          <option [value]="visitStatus.Doing"> در حال انجام </option>
          <option [value]="visitStatus.Done"> انجام شده </option>
        </select>
      </div>
    </div>
  </div>

  <div class="flex-auto p-3">
      <div class="relative w-full overflow-x-auto rounded-md">
          <table class="w-full bg-transparent border-collapse">
            <thead class="bg-primary text-white">
              <tr>
                <th class="align-middle border border-solid p-3 text-base border-l-0 border-r-0 font-semibold" >
                  نوع ویزیت
                </th>
                <th class="align-middle border border-solid p-3 text-base border-l-0 border-r-0 font-semibold"  >
                  نام بیمار
                </th>
                <th class="align-middle border border-solid p-3 text-base border-l-0 border-r-0 font-semibold" >
                  تاریخ
                </th>
                <th class="align-middle border border-solid p-3 text-base border-l-0 border-r-0 font-semibold" >
                  ساعت شروع
                </th>
                <th class="align-middle border border-solid p-3 text-base border-l-0 border-r-0 font-semibold" >
                  ساعت پایان
                </th>
                <th class="align-middle border border-solid p-3 text-base border-l-0 border-r-0 font-semibold" >
                  وضعیت
                </th>
                <th class="align-middle border border-solid p-3 text-base border-l-0 border-r-0 font-semibold" >
                  مدارک پزشکی
                </th>
                <th class="align-middle border border-solid p-3 text-base border-l-0 border-r-0 font-semibold" >
                  وضعیت پرداخت
                </th>
                <th class="align-middle border border-solid p-3 text-base border-l-0 border-r-0 font-semibold" >
                  آپلود نسخه 
                </th>
                <th class="align-middle border border-solid p-3 text-base border-l-0 border-r-0 font-semibold"  >
                  لغو ویزیت
                </th>
                <th class="align-middle border border-solid p-3 text-base border-l-0 border-r-0 font-semibold" >
                  ویزیت
                </th>
              </tr>
            </thead>
            <tbody>
              <tr class="border-b" *ngFor="let appointment of appointmentsList">
                <td class="border-t-0 align-middle text-sm p-3" >
                {{appointment.type==1?'متنی':appointment.type==2?'تلفنی':appointment.type==3?'تصویری':appointment.type==4?'حضوری':null}}
                </td>
                <td class="border-t-0 align-middle text-sm p-3">
                   {{appointment.userName}}
                </td>
                <td class="border-t-0 align-middle text-sm p-3">
                    {{(appointment.date|shamsiDate)}}
                </td>
                <td class="border-t-0 align-middle text-sm p-3">
                  {{convertUTCMinutesToLocal(appointment.startCounter)!='00:00'?convertUTCMinutesToLocal(appointment.startCounter):'---'}}
                </td>
                <td class="border-t-0 align-middle text-sm p-3">
                  {{calculateTime(appointment.endCounter)!='00:00'?calculateTime(appointment.endCounter):'---'}}
                </td>
                <td class="border-t-0 align-middle text-sm p-3">
                   {{appointment.status==1?'در انتظار تایید':appointment.status==2?'تایید شده':appointment.status==3?'در حال انجام':appointment.status==4?'انجام شده':appointment.status==5?'کنسل شده':null}}
                </td>
                <!-- <td
                  class="border-t-0 align-middle text-sm p-3"
                >
                  {{appointment.category}}
                </td> -->
                <td class="border-t-0 align-middle text-sm p-3 flex items-center">
                  <button (click)="tempVisit=appointment;uploadedFile.open()" class="h-12 w-12 bg-white rounded-full cursor-pointer p-2 hover:bg-gray-100" >
                     <img src="../../../../assets/img/icon/document-upload.svg" class="w-9 h-8" alt="..."/>
                  </button>
                </td>
                <td class="border-t-0 align-middle text-sm p-3">
                   {{appointment.paymentStatus==1?'در انتظار تایید':appointment.paymentStatus==2?'تایید شده':appointment.paymentStatus==3?'تایید نشده':null}}
                </td>
                <td class="border-t-0 align-middle text-sm p-3 flex items-center">
                  <button (click)="tempVisit=appointment;drFile.open()" class="h-12 w-12 bg-white rounded-full cursor-pointer p-2 hover:bg-gray-100" >
                    <img src="../../../../assets/img/icon/document-upload.svg" class="w-9 h-8" alt="..."/>
                  </button>
                  <!-- <label class="h-12 w-12 bg-white rounded-full cursor-pointer p-2 hover:bg-gray-100" 
                  [for]="'document_upload'+appointment.id"> <img src="../../../../assets/img/icon/document-upload.svg"               
                   class="w-9 h-8" alt="..."/></label>
                  <input type="file" [id]="'document_upload'+appointment.id" (change)="onSelectFile($event, appointment.id)" accept="image/*,.pdf" style="display: none;"> -->
                </td>
                <td class="border-t-0 align-middle text-sm p-3">
                  <div class="flex">
                    <button class="w-10 h-10 rounded-full cursor-pointer flex justify-center items-center disabled:cursor-not-allowed " 
                      [disabled]="appointment.status==5||isActiveVisitLink(appointment.date, appointment.startCounter)||appointment.isOpen" (click)="visitId=appointment.id;modal.open();"> <img
                      src="../../../../assets/img/icon/cancel.svg" [ngStyle]="{'filter':appointment.status==5||isActiveVisitLink(appointment.date, appointment.startCounter)? 'grayscale(1)':null}"
                      alt="..." class="w-8 h-8"
                    /></button>
                  </div>
                </td>
                <td class="border-t-0 align-middle text-sm p-3">
                <button *ngIf="appointment.type==visitType.TextVisit" class="bg-primary text-white rounded pb-2 pt-1 px-3 text-sm disabled:cursor-not-allowed disabled:bg-gray-200" type="button" 
                [routerLink]="['/doctor-panel/chat/'+appointment.id]" [disabled]="appointment.paymentStatus!=2"> ورود </button>
                
                <button *ngIf="appointment.type==visitType.PhoneVisit" class="bg-primary text-white rounded pb-2 pt-1 px-3 text-sm disabled:cursor-not-allowed disabled:bg-gray-200" type="button" 
                  [routerLink]="['/doctor-panel/visit-link/'+appointment.id]" [disabled]="isActiveVisitLink(appointment.date, appointment.endCounter)||appointment.paymentStatus!=2"> ورود </button>
                
                <button *ngIf="appointment.type==visitType.VideoVisit" class="bg-primary text-white rounded pb-2 pt-1 px-3 text-sm disabled:cursor-not-allowed disabled:bg-gray-200" type="button" 
                [routerLink]="['/doctor-panel/visit-link/'+appointment.id]" [disabled]="isActiveVisitLink(appointment.date, appointment.endCounter)||appointment.paymentStatus!=2" > ورود </button>
                
                <span *ngIf="appointment.type==visitType.BodyVisit" class="text-sm" > --- </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="card flex justify-center">
          <p-paginator dir="rtl" (onPageChange)="getAppointmentList($event.page+1)" [first]="first" [rows]="rows"
            [totalRecords]="collectionSize" [showCurrentPageReport]="true" [showPageLinks]="false"
            [showJumpToPageDropdown]="false" currentPageReportTemplate="نمایش {first} تا {last} از {totalRecords} رکورد" />
        </div>
  </div>
</div>
  

<p-toast dir="rtl"></p-toast>

<!-- MODAL SECTION -->


<app-modal #image>
  <!--header-->
  <div class="flex items-start justify-between p-2 border-b border-solid border-blueGray-200 rounded-t">
    <h3 class="text-2xl font-semibold">
      بارگزاری تصویر   
    </h3>
    <button class="p-1 bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none" (click)="image.close()">
      <span class="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
        ×
      </span>
    </button>
  </div>
  <!--body-->
  <div class="relative p-6 flex-auto">
    <image-cropper
        [imageChangedEvent]="imageChangedEvent"
        [maintainAspectRatio]="true"
        [aspectRatio]="1 / 1"
        [onlyScaleDown]="true"
        [roundCropper]="false"
        [alignImage]="'center'"
        [hideResizeSquares]="false"
        [style.display]="showCropper ? null : 'none'"
        format="png"
        (imageCropped)="imageCropped($event)"
        (imageLoaded)="imageLoaded($event)"
        (cropperReady)="cropperReady()"
        (loadImageFailed)="loadImageFailed()"
        style="max-width: 550px;max-height: 450px;"
    ></image-cropper>
  </div>
  <!--footer-->
  <div class="flex items-center justify-between border-solid border-blueGray-200 rounded-b">
    <button class="text-red-500 border-red-500 background-transparent font-bold px-6 py-2 rounded text-sm my-2 ease-linear transition-all duration-150" type="button" (click)="image.close()">
      انصراف
    </button>
    <button (click)="addFile()" class="bg-primary text-white active:bg-red-500 font-bold text-sm px-6 py-2 rounded shadow hover:shadow-lg my-2 ease-linear transition-all duration-150" type="button">
      تایید
    </button>
  </div>
</app-modal>

<app-modal #modal>
  <!--header-->
  <div class="flex items-start justify-between p-2 border-b border-solid border-blueGray-200 rounded-t">
    <h3 class="text-2xl font-semibold">
      لغو ویزیت 
    </h3>
    <button
      class="p-1 bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
      (click)="modal.close()">
      <span class="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
        ×
      </span>
    </button>
  </div>
  <!--body-->
  <div class="relative p-6 flex-auto">
    <p class="mt-4 mb-12 text-blueGray-500 text-lg text-start leading-relaxed">
      آیا برای لغو این ویزیت اطمینان دارید؟ 
      <br>
      در صورت لغو، با کسر درصد سایت از حساب شما، هزینه ویزیت به حساب بیمار عودت خواهد شد.
    </p>
  </div>
  <!--footer-->
  <div class="flex items-center justify-between py-2 border-solid border-blueGray-200 rounded-b">
    <button
      class="text-red-500 border-red-500 background-transparent font-bold px-6 py-2 rounded text-sm my-2 ease-linear transition-all duration-150"
      type="button" (click)="modal.close();">
      انصراف
    </button>
    <button
      class="bg-primary text-white active:bg-red-500 font-bold text-sm px-6 py-2 rounded shadow hover:shadow-lg my-2 ease-linear transition-all duration-150"
      type="button" (click)="visitCancel()">
      تایید
    </button>
  </div>
</app-modal>

<app-modal #drFile>
  <!--header-->
  <div class="flex items-start justify-between p-2 border-b border-solid border-blueGray-200 rounded-t">
    <h3 class="text-2xl font-semibold">
      نمایش نسخه
    </h3>
    <button
      class="p-1 bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
      (click)="drFile.close()">
      <span class="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
        ×
      </span>
    </button>
  </div>
  <!--body-->
  <div class="relative p-6 flex-auto">
    <p *ngIf="!tempVisit?.doctorUploadFile||tempVisit?.doctorUploadFile==''" class="mt-4 mb-12 text-blueGray-500 text-lg text-start leading-relaxed">
      فایلی بارگزاری نشده است. 
    </p>
    <img *ngIf="getFileExtension(tempVisit?.doctorUploadFile)!='pdf'" [src]="apiService.api+tempVisit?.doctorUploadFile" class="max-w-md" alt="">
    <a class="flex items-center" *ngIf="getFileExtension(tempVisit?.doctorUploadFile)=='pdf'" [href]="apiService.api+tempVisit?.doctorUploadFile" target="_blank">
    <img src="../../../../assets/img/icon/file.svg" alt="">
    <span class="font-bold px-3"> نمایش فایل</span>
    </a>
  </div>
  <!--footer-->
  <div class="flex items-center justify-between py-2 border-solid border-blueGray-200 rounded-b">
    <button
      class="text-red-500 border-red-500 background-transparent font-bold px-6 py-2 rounded text-sm my-2 ease-linear transition-all duration-150"
      type="button" (click)="drFile.close();">
      انصراف
    </button>
    <label for="document_upload"
      class="bg-primary text-white active:bg-red-500 font-bold text-sm px-6 py-2 rounded shadow hover:shadow-lg my-2 ease-linear transition-all duration-150">
      بارگزاری فایل
    </label>
    <input type="file" id="document_upload" (change)="onSelectFile($event)" accept="image/*,.pdf" style="display: none;">
  </div>
</app-modal>


<app-modal #uploadedFile>
  <!--header-->
  <div class="flex items-start justify-between p-2 border-b border-solid border-blueGray-200 rounded-t">
    <h3 class="text-2xl font-semibold">
      مدارک پزشکی
    </h3>
    <button
      class="p-1 bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
      (click)="uploadedFile.close()">
      <span class="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
        ×
      </span>
    </button>
  </div>
  <!--body-->
  <div class="relative p-6 flex-auto border-b" *ngIf="tempVisit?.files.length==0">
    <p class="mt-4 mb-12 text-blueGray-500 text-lg text-start leading-relaxed">
      فایلی بارگزاری نشده است. 
    </p>
  </div>
  <div class="relative p-6 flex-auto border-b" *ngFor="let file of tempVisit?.files">
    <!-- <a [href]="apiService.api+file" target="_blank">
    <img [src]="apiService.api+file" class="max-w-150-px" alt="">
    </a> -->

    <a [href]="apiService.api+file" target="_blank">
      <img *ngIf="getFileExtension(file)=='png'||getFileExtension(file)=='jpg'||getFileExtension(file)=='jpeg'" class="max-w-180-px h-auto" [src]="apiService.api+file" alt="">  
      <img *ngIf="getFileExtension(file)!=='png'&&getFileExtension(file)!=='jpg'&&getFileExtension(file)!=='jpeg'" src="../../../../assets/img/icon/file.svg" alt="">  
      <span *ngIf="getFileExtension(file)!=='png'&&getFileExtension(file)!=='jpg'&&getFileExtension(file)!=='jpeg'" class="font-bold px-3"> {{getFileExtension(file)}} </span>
    </a>
  </div>
  <!--footer-->
  <div class="flex items-center justify-end py-2 border-solid border-blueGray-200 rounded-b">
    <button
      class="text-red-500 border-red-500 background-transparent font-bold px-6 py-2 rounded text-sm my-2 ease-linear transition-all duration-150"
      type="button" (click)="uploadedFile.close();">
      بستن
    </button>
  </div>
</app-modal>